import type {
  CurrentAdminUser,
  LoginRequest,
  LoginResponse
} from '@bo-types/authentication';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { admin } = apiPaths;

export const authenticationApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginRequest>({
      query: (payload) => ({
        url: `${admin}login`,
        method: 'POST',
        body: payload,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      invalidatesTags: ['Authentication', 'AlertNotificationsCount']
    }),
    googleLoginCallBack: build.mutation<
      LoginResponse,
      google.accounts.id.CredentialResponse
    >({
      query: (payload) => ({
        url: `${admin}google_onetap_callback`,
        method: 'POST',
        body: payload,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      invalidatesTags: ['Authentication', 'AlertNotificationsCount']
    }),
    getAdminCurrent: build.query<CurrentAdminUser, void>({
      query: () => ({
        url: `${admin}current`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      providesTags: ['Authentication']
    }),
    logout: build.mutation<void, void>({
      query: () => ({
        url: `${admin}logout`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      invalidatesTags: ['Authentication']
    })
  })
});

export const {
  useGetAdminCurrentQuery,
  useLoginMutation,
  useGoogleLoginCallBackMutation,
  useLogoutMutation
} = authenticationApi;
